<div class="tree-node" [class.selected]="isNodeSelected(node)" [class]="getNodeClass()">
  <div class="node-content" (click)="selectNode(node)">
    <i [class]="getNodeIconClass(node)"></i>
    <span class="node-name">{{ node.name }}</span>
    <span class="user-count">({{ getDisplayUserCount(node) }})</span>
    <span class="expand-icon" *ngIf="isExpandable(node)"
          (click)="toggleNode(node, $event)">
      <i class="fas" [class.fa-chevron-right]="!node.expanded"
         [class.fa-chevron-down]="node.expanded"></i>
    </span>
  </div>

  <!-- 遞歸顯示子部門 -->
  <div class="tree-children" *ngIf="node.expanded && getDepartmentChildren(node).length > 0">
    <app-organization-tree-node
      *ngFor="let child of getDepartmentChildren(node)"
      [node]="child"
      [selectedDepartment]="selectedDepartment"
      [isRootNode]="false"
      [level]="level + 1"
      (nodeSelected)="nodeSelected.emit($event)"
      (nodeToggled)="nodeToggled.emit($event)">
    </app-organization-tree-node>
  </div>
</div>
